import * as layout from '../../components/markLayout.module.css';
import React, { useMemo } from 'react';
import Table from '@hero/ui-kit/tables/Table';
import type { Contact } from '../../types';
import getTableColumns from './getTableColumns';
import usePagerProps from '../../../../hooks/usePagerProps';
type Props = {
    contacts: Contact[];
    isLoading: boolean;
    pagerProps: ReturnType<typeof usePagerProps>;
};
const ContactList: React.FC<Props> = ({ contacts, isLoading, pagerProps }) => {
    const columns = useMemo(() => getTableColumns(), []);
    return (
        <div
            style={{
                overflowX: 'auto'
            }}
            className={layout.tableScroll}
        >
            <Table<Contact>
                columns={columns}
                data={contacts}
                rowKey="profile_id"
                emptyValues="-"
                isLoading={isLoading}
                pagerProps={pagerProps}
            />
        </div>
    );
};
export default ContactList;
